var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04158 4.47998L7.40204 6.33582C7.75035 8.1291 9.15257 9.5313 10.9459 9.87958L12.8019 10.24L10.9459 10.6005C9.15257 10.9488 7.75035 12.351 7.40204 14.1443L7.04158 16.0001L6.68112 14.1443C6.33281 12.351 4.93058 10.9488 3.1373 10.6005L1.28125 10.24L3.1373 9.87958C4.93058 9.5313 6.33281 8.1291 6.68112 6.33582L7.04158 4.47998Z",
    fill: "#A187B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5202 0L3.79501 1.27971C4.00649 2.2645 4.77577 3.03376 5.76057 3.24522L7.0404 3.52004L5.76057 3.79485C4.77577 4.00632 4.00649 4.77558 3.79501 5.76037L3.5202 7.04008L3.24539 5.76037C3.03391 4.77558 2.26463 4.00632 1.27983 3.79485L0 3.52004L1.27983 3.24522C2.26463 3.03376 3.03391 2.2645 3.24539 1.27971L3.5202 0Z",
    fill: "#E8CCBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1972 2.5603L11.4194 3.59531C11.5252 4.0877 11.9098 4.47233 12.4022 4.57807L13.4373 4.80033L12.4022 5.02259C11.9098 5.12832 11.5252 5.51295 11.4194 6.00535L11.1972 7.04035L10.9749 6.00535C10.8692 5.51295 10.4845 5.12832 9.99212 5.02259L8.95703 4.80033L9.99212 4.57807C10.4845 4.47233 10.8692 4.0877 10.9749 3.59531L11.1972 2.5603Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.7fd2c2220aab83901675f998bd586731.svg";
export { ForwardRef as ReactComponent };